import styles from '@/pages/app/BillingOps/styles.module.scss'

import { OperationDescriptor } from '@/api/generated'
import { ENGINEERING_ONLY_KINDS } from '@/pages/app/BillingOps/types'

const ACRONYMS = new Set(['po', 'id', 'url', 'api'])

const formatKind = (kind: string): string =>
  kind
    .split('_')
    .map((word) => (ACRONYMS.has(word) ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1)))
    .join(' ')

interface OperationListProps {
  operations: OperationDescriptor[]
  selectedKind: string | null
  onSelect: (kind: string) => void
}

const OperationList = ({ operations, selectedKind, onSelect }: OperationListProps) => (
  <div className={styles.opList}>
    {operations.map((op) => {
      const isActive = op.kind === selectedKind
      const className = [styles.opItem, isActive ? styles.opItemActive : '', op.enabled ? '' : styles.opItemDisabled]
        .filter(Boolean)
        .join(' ')
      return (
        <button
          key={op.kind}
          className={className}
          disabled={!op.enabled}
          onClick={() => onSelect(op.kind)}
          type="button"
        >
          <span className={styles.opItemKind}>
            {formatKind(op.kind)}
            {ENGINEERING_ONLY_KINDS.has(op.kind) && (
              <span className={styles.engineeringOnlyBadge}>Engineering only, support: do not use</span>
            )}
          </span>
          <span className={styles.opItemDescription}>{op.description}</span>
        </button>
      )
    })}
  </div>
)

export default OperationList
